<template>
  <div class="index">
    <header>
      <div class="content w">
        <a href="javascript:;" @click="toTop('heads')" class="logo-wraper">
          <img src="static/img/logo.png" alt />
        </a>
        <nav>
          <div v-for="(item,index) in navList" :key="index" @click="toTop(item.id)">
            <div :class="item.id===activeItem?'active':''">{{item.txt}}</div>
          </div>
        </nav>
      </div>
    </header>
    <main id="heads">
      <div class="con-item">
        <img src="static/img/banner.png" alt />
        <div class="w list-wrapper">
          <div v-for="(item,index) in bannerlist" :key="index" class="item-wrapper">
            <img :src="item.img" alt />
            <div class="banner-list-title">{{item.title}}</div>
            <div class="banner-list-hit">{{item.content}}</div>
          </div>
        </div>
      </div>

      <div class="con-item" id="About_us">
        <div class="title-wrapper">
          <div class="title-txt">{{language.v_index_About_us}}</div>
          <div class="title-hit">{{language.v_title_hit}}</div>
        </div>
        <img class="w" src="static/img/banner2.png" alt />
        <div class="txt-hit w">{{language.v_aboutus_hit1}}</div>
        <div class="txt-hit w">{{language.v_aboutus_hit2}}</div>
      </div>

      <div class="con-item" id="Business">
        <div class="title-wrapper">
          <div class="title-txt">{{language.v_index_con2_tit}}</div>
          <div class="title-hit">{{language.v_title_hit}}</div>
        </div>
        <div class="list-wrapper w">
          <div class="list-item">
            <img src="static/img/con3/1.png" alt />
            <div class="item-content">
              <img src="static/img/con3/1_1.png" alt />
              <div class="title">{{language.v_index_con3_con11}}</div>
            </div>
            <div class="hit">{{language.v_index_con3_con12}}</div>
          </div>

          <div class="list-item">
            <img src="static/img/con3/2.png" alt />
            <div class="item-content">
              <img src="static/img/con3/2_1.png" alt />
              <div class="title">{{language.v_index_con3_con21}}</div>
            </div>
            <div class="hit">{{language.v_index_con3_con22}}</div>
          </div>

          <div class="list-item">
            <img src="static/img/con3/3.png" alt />
            <div class="item-content">
              <img src="static/img/con3/3_1.png" alt />
              <div class="title">{{language.v_index_con3_con31}}</div>
            </div>
            <div class="hit">{{language.v_index_con3_con32}}</div>
          </div>
        </div>
      </div>
      <div class="con-item" id="Advantages">
        <div class="title-wrapper">
          <div class="title-txt">{{language.v_index_Core_Advantages}}</div>
          <div class="title-hit">{{language.v_title_hit}}</div>
        </div>
        <div class="w">
          <el-carousel class="el-carous" height="440px" arrow="always">
            <el-carousel-item v-for="(item,index) in swipers" :key="index">
              <div class="imglist">
                <div class="imgitem" v-for="(item1,index1) in item" :key="index1">
                  <img :src="item1.img" alt />
                  <div class="cover-img">
                    <img src="static/img/logo-big.png" alt />
                    <div>{{item1.tit}}</div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="con-item" id="Where_we_are">
        <img src="static/img/map.png" alt />
      </div>

      <div class="con-item" id="Cooperation_Partner">
        <img src="static/img/partener.png" alt />
        <div class="cover">
            <img src="static/img/logo-big.png" alt />
            <div class="txt">
              {{language.v_index_con6_tit}}
            </div>
            <div class="btn">
              {{language.v_title_hit}}
            </div>
        </div>
      </div>
    </main>
    <footer>{{language.v_index_foot2}}</footer>
  </div>
</template>

<script>
import language from "../language/index.js";
import $ from "jquery";
export default {
  name: "index",
  data() {
    return {
      navList: [
        {
          id: "heads",
          txt: language.v_index_homepage,
        },
        {
          id: "About_us",
          txt: language.v_index_About_us,
        },
        {
          id: "Business",
          txt: language.v_index_con2_tit,
        },
        {
          id: "Advantages",
          txt: language.v_index_Core_Advantages,
        },
        {
          id: "Where_we_are",
          txt: language.v_index_con4_tit,
        },
        {
          id: "Cooperation_Partner",
          txt: language.v_index_con6_tit,
        },
      ],
      bannerlist: [
        {
          img: "static/img/bannerlist/1.png",
          title: language.v_index_con1_con11,
          content: language.v_index_con1_con12,
        },
        {
          img: "static/img/bannerlist/2.png",
          title: language.v_index_con1_con21,
          content: language.v_index_con1_con22,
        },
        {
          img: "static/img/bannerlist/3.png",
          title: language.v_index_con1_con31,
          content: language.v_index_con1_con32,
        },
        {
          img: "static/img/bannerlist/4.png",
          title: language.v_index_con1_con41,
          content: language.v_index_con1_con42,
        },
      ],
      language,
      activeItem: "heads",
      swipers: [
        [
          { img: "static/img/con5/1.png", tit: "Beijing,China" },
          { img: "static/img/con5/2.png", tit: "Hangzhou,China" },
          { img: "static/img/con5/3.png", tit: "Nanjing,China" },
          { img: "static/img/con5/4.png", tit: "Guangzhou,China" },
        ],
        [
          { img: "static/img/con5/5.png", tit: "Shanghai,China" },
          { img: "static/img/con5/6.png", tit: "Singapore" },
          { img: "static/img/con5/7.png", tit: "Africa" },
          { img: "static/img/con5/8.png", tit: "Philippines" },
        ],
        [
          { img: "static/img/con5/9.png", tit: "Vietnam" },
          { img: "static/img/con5/10.png", tit: "India" },
          { img: "static/img/con5/11.png", tit: "Indonesia" },
          { img: "static/img/con5/12.png", tit: "Nigeria" },
        ],
      ],
    };
  },
  methods: {
    toTop(str) {
      this.activeItem = str;
      $("html, body").animate(
        { scrollTop: $("#" + str + "").offset().top - 50 },
        200
      );
    },
  },
  mounted() {},
};
</script>

<style lang="less">

.index {
  position: relative;
  font-size: 16px;
  padding: 0.1px;
  .w {
    margin: 0 auto;
    width: 1200px;
  }
  header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background: #ffffff;
    box-shadow: 0 4px 10px 0 rgba(145, 145, 145, 0.2);
    overflow: hidden;
    .content {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .logo-wraper {
        flex: 0 0 340px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 116px;
        }
      }
      nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        & > div {
          font-size: 14px;
          height: calc(100% - 1.5px);
          color: #212121;
          border-bottom: 1.5px solid #ffffff;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            color: #306ed0;
          }
          .active {
            background: #f7f7f7;
            border-radius: 4px;
            color: #3760f4;
            padding: 0 15px;
            height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
  main {
    padding-top: 60px;
    .title-wrapper {
      .title-txt {
        font-size: 44px;
        color: #3a4564;
        text-align: center;
      }
      .title-hit {
        font-size: 18px;
        color: #3a4564;
        text-align: center;
        padding-top: 14px;
      }
    }
    .con-item {
      &:nth-child(1) {
        position: relative;
        & > img {
          width: 100%;
        }
        .list-wrapper {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -108px;
          display: flex;
          height: 272px;
          background: #ffffff;
          border: 1px solid #e2e6ef;
          box-shadow: 0 1px 1px 0 #f8f9ff;
          margin-top: -108px;
          z-index: 1;
          .item-wrapper {
            flex: 1;
            position: relative;
            text-align: left;
            padding: 50px 38px 0 48px;
            background: #fff;
            img {
              position: absolute;
              left: 48px;
              top: 0;
              transform: translateY(-50%);
              width: 80px;
            }
            .banner-list-title {
              font-size: 20px;
              color: #3a4564;
              padding-bottom: 16px;
            }
            .banner-list-hit {
              font-size: 14px;
              color: #7e8ba4;
              line-height: 18px;
            }
          }
        }
      }
      &:nth-child(2) {
        background: #f9faff;
        height: 1080px;
        padding-top: 206px;
        img {
          display: block;
          margin-top: 40px;
        }
        .txt-hit {
          font-size: 18px;
          color: #7e8ba4;
          line-height: 24px;
          padding-top: 31px;
        }
      }
      &:nth-child(3) {
        padding-top: 150px;
        padding-bottom: 80px;
        .list-wrapper {
          padding-top: 80px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .list-item {
            width: 380px;
            height: 440px;
            padding: 26px;
            background: #ffffff;
            border: 1px solid #E2E6EF;
            box-shadow: 0 1px 1px 0 #F8F9FF;
            & > img {
              width: 328px;
            }
            &:hover {
              box-shadow: 0 1px 16px 0 #EEF1FF;
            }
          }
          .item-content {
            display: flex;
            align-items: center;
            padding: 26px 0 20px;
            & > img {
              width: 20px;
            }
            .title {
              font-size: 19px;
              color: #3a4564;
              padding-left: 10px;
              word-break: break-all;
            }
          }
          .hit {
            font-size: 14px;
            color: #7e8ba4;
            line-height: 18px;
          }
        }
      }
      &:nth-child(4) {
        padding-top: 90px;
        padding-bottom: 180px;
        .w {
          padding-top: 80px;
          .el-carous {
            background: #ffffff;
            border: 1px solid #e2e6ef;
            box-shadow: 0 1px 1px 0 #f8f9ff;
            height: 440px;
            .el-carousel__arrow {
              display: block;
              &.el-carousel__arrow--right {
                color: rgba(0,0,0,0);
                background: url(../../static/img/next.png) no-repeat center/100% 100%;
                &:hover{
                  background: url(../../static/img/next_active.png) no-repeat center/100% 100%;
                }
              }
              &.el-carousel__arrow--left {
                background: url(../../static/img/pre.png) no-repeat center/100% 100%;
                color: rgba(0,0,0,0);
                &:hover{
                  background: url(../../static/img/pre_active.png) no-repeat center/100% 100%;
                }
              }
            }
            .imglist {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 133px;
              height: 440px;
              .imgitem {
                width: 211px;
                height: 318px;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                }
                .cover-img {
                  
                  display: none;
                  position: absolute;
                  left: 0;
                  right: 0;
                  top: 0;
                  bottom: 0;
                  border-radius: 4px;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                  &::before{
                    border-radius: 4px;
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    opacity: 0.4;
                    background: #000000;
                    z-index: 1;
                  }
                  
                  img {
                    width: 63px;
                    height: 63px;
                    margin-bottom: 14px;
                    position: static;
                    z-index: 2;
                  }
                  div {
                    font-size: 18px;
                    color: #ffffff;
                    text-align: center;
                    position: static;
                    z-index: 2;
                  }
                }
                &:hover {
                  .cover-img {
                    display: flex;
                  }
                }
              }
            }
          }
        }
      }
      &:nth-child(5) {
        img {
          width: 100%;
        }
      }
      &:nth-child(6) {
        position: relative;
        img {
          width: 100%;
        }
      .cover {
          display: flex;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          z-index: 2;
          &::before{
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            opacity: 0.5;
            background: #000000;
            z-index: 1;
          }
          img {
            width: 93px;
            height: 93px;
            position: static;
            z-index: 2;
          }
          .txt {
            font-size: 44px;
            color: #FFFFFF;
            text-align: center;
            position: static;
            padding: 5px 0 20px;
            z-index: 2;
          }
          .btn{
            background: #4362EB;
            width: 205px;
            height: 42px;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
             position: static;
             z-index: 2;
          }
        }
         &:hover {
            .cover {
              display: none;
            }
          }
      }
    }
  }
  footer {
    width: 100%;
    height: 128px;
    line-height: 128px;
    text-align: center;
    background: #0c1631;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue